import { StepperList, Label, Alert, Tooltip, InputField, ReactSelectBox, Tabs, PopupDialogbox, EventHandler } from "../../../../CommonComponents";
import "./VehicleRequestDetail.scss";
import ItemDetail from "./ItemDetail";
import { formatLableValue, getBooleanYesNo } from "utils";
import { CONSTANTS } from "client/utils/constants";
import editIcon from '../../../../assets/images/Edit.svg'
import saveIcon from '../../../../assets/images/Save.svg'
import permissions, { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import AssetItemStatusContainer from "../../PurchaseBulkOrder/AssetItemStatus/AssetItemStatus-container";
import ChangeLog from "../../PurchaseOrder/ChangeLog/ChangeLog-container";
import VendorEmailHistoryContainer from "../VendorEmailHistory/VendorEmailHistory-container";
import PurchaseOrderHistory from "../PurchaseOrderHistory";

interface IProps {
  orderDetails?: any;
  stepperListData?: any;
  handleClickNext?: any;
  handleClickPrevious?: any;
  StepperRef?: any;
  activeStepper?: any;
  panelList?: any;
  FleetRequestVehicleDetail?: any;
  SelectedVehiclesCount?: any;
  assignTo?: any;
  itemDetails?: any;
  accordionIndex?: any;
  dismissAlert: Function;
  error?: any;
  handleChange?: Function;
  handleChangeDropDown?: Function;
  purchaseOrderStepperData?: any;
  errors: any;
  onCloseLinkAttachment?: any
  onChangeLinkAttachment?: any
  onClicktLinkAttachment?: any
  isAttachmentBtnClicked?: any
  getLinkedAttachmentsCount?: any
  attachmentsList?: any
  linkedAttachment?: any
  assignedToError?: any
  skipVendorDetail?: any
  check?: any
  onClickAttachment?: any,
  savedStatus?: any,
  yearDropdownList?: any,
  usedDropdownList?: any,
  enableEditNSE?: any,
  handleClickEditNSE?: any,
  handleClickSaveNSE?: any,
  editAssetInfo?: any,
  onChangeMake?: any,
  onChangeModel?: any,
  onChangeYear?: any,
  onChangeUsed?: any,
  onChangePrice?: any,
  unitPriceFormat?: any,
  setCancelledItemFleetId?: any
  isBulkOrder: boolean
  list?: any
  setList?: any
  uploadedList?: any
  onUploadClick?: any
  attachmentError?: any
  setAttachmentError?: any
  onRemoveClick: any
  autoSaveComments: Function,
  isnonStandardequipment?: boolean,
  ismanagedequipment?: boolean,
  isvehiclerequestequipment?: boolean
  isRequisitionComplete?: any
  onClickReturnToHome: Function,
  isVendorDetailsSkippedOnSave?: any
  onChnageQuoteAttached: (e: any, value: boolean) => void,
  onDescriptionChange?: any,
  onClickViewPurchaseOrder: any,
  onClickSendPoToVendor?: any,
  showEmailPopup?: any,
  hidePopup?: any,
  handleClickTriggerEmail?: any,
  setSendEmailAttachmentsList?: any,
  sendEmailAttachmentsList?: any,
  setSendEmailList?: any,
  sendEmailList?: any,
  setEmailAttachmentError?: any,
  emailAttachmentError?: any,
  sendEmailError?: any,
  setSendEmailerror?: any,
  dismissMailAlert?: any,
  isEmailSentAlert?: any,
  isPoVendorEmailSent?: any,
  Popupcontent?: any,
  hideDialog?: any,
  popupOutlinebtnOnclick?: any,
  onClickRefreshPurchaseOrder?: any,
  isRefreshError?: any,
  handleLinkClick?: any,
  handleClickReturnToRequestor?: any,
  returnPopupcontent?: any,
  returnSuccessPopupContent?: any
}
const VehicleRequestDetail = ({
  itemDetails,
  SelectedVehiclesCount,
  orderDetails,
  stepperListData,
  handleClickNext,
  handleClickPrevious,
  StepperRef,
  activeStepper,
  panelList,
  assignTo,
  accordionIndex,
  dismissAlert,
  error,
  handleChange,
  purchaseOrderStepperData,
  handleChangeDropDown,
  errors,
  onCloseLinkAttachment,
  onChangeLinkAttachment,
  onClicktLinkAttachment,
  isAttachmentBtnClicked,
  getLinkedAttachmentsCount,
  attachmentsList,
  linkedAttachment,
  assignedToError,
  skipVendorDetail,
  check,
  onClickAttachment,
  savedStatus,
  yearDropdownList,
  usedDropdownList,
  enableEditNSE,
  handleClickEditNSE,
  handleClickSaveNSE,
  editAssetInfo,
  onChangeMake,
  onChangeModel,
  onChangeYear,
  onChangeUsed,
  onChangePrice,
  unitPriceFormat,
  setCancelledItemFleetId,
  isBulkOrder,
  list,
  setList,
  uploadedList,
  onUploadClick,
  attachmentError,
  setAttachmentError,
  onRemoveClick,
  autoSaveComments,
  isnonStandardequipment,
  ismanagedequipment,
  isvehiclerequestequipment,
  isRequisitionComplete,
  onClickReturnToHome,
  isVendorDetailsSkippedOnSave,
  onChnageQuoteAttached,
  onDescriptionChange,
  onClickViewPurchaseOrder,
  onClickSendPoToVendor,
  showEmailPopup,
  hidePopup,
  handleClickTriggerEmail,
  setSendEmailAttachmentsList,
  sendEmailAttachmentsList,
  setSendEmailList,
  sendEmailList,
  setEmailAttachmentError,
  emailAttachmentError,
  setSendEmailerror,
  sendEmailError,
  dismissMailAlert,
  isEmailSentAlert,
  isPoVendorEmailSent,
  Popupcontent,
  hideDialog,
  popupOutlinebtnOnclick,
  onClickRefreshPurchaseOrder,
  isRefreshError,
  handleLinkClick,
  handleClickReturnToRequestor,
  returnPopupcontent,
  returnSuccessPopupContent
}: IProps) => {
  const ReceivingIssuesList = (receivingIssues: any) => {
    return (
      <ul className="recievingissues_list">
        {receivingIssues.map((issue : any, index : any) =>(
          <li key={index}>{issue}</li>
        ))}
      </ul>
    );
  };

  const getEquipmentType = () => {
    if (itemDetails?.orderRequestSubType) {
      return itemDetails?.orderRequestSubType
    } else {
      return "-"
    }
  }

  const tabItem = () => {
    let val = [
      {
        itemKey: "changelog-bukorderfleet",
        headerText: "CHANGE LOG",
        content: <ChangeLog fleetRequestDetailId={itemDetails?.fleetRequestDetailId} activeStepper={activeStepper} skipVendorDetail={skipVendorDetail} setCancelledItemFleetId={setCancelledItemFleetId} />
      },
      {
        itemKey: "assetitemstatus-bukorderfleet",
        headerText: "ASSET ITEM STATUS",
        content: <AssetItemStatusContainer skipVendorDetail={isVendorDetailsSkippedOnSave} fleetRequestDetailId={itemDetails?.fleetRequestDetailId} isBulkOrder={false} />
      }
    ]
    if ((isAuthorized(permissions.View_VendorEmail_HistoryTab) && itemDetails?.canCreatePoPdf && !purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber') && purchaseOrderStepperData?.assetNumber && purchaseOrderStepperData?.poNumber)) {
      val.push({
        itemKey: "vendorEmailHistory-bukorderfleet",
        headerText: "VENDOR EMAIL HISTORY",
        content: <VendorEmailHistoryContainer fleetRequestDetailId={itemDetails?.fleetRequestDetailId} poNumber={itemDetails?.poNumber} />,
      })
    }
    if ((isAuthorized(permissions.View_PO_HistoryTab) && itemDetails?.canCreatePoPdf && !purchaseOrderStepperData?.pocipDetails?.hasOwnProperty('cippoNumber') && purchaseOrderStepperData?.assetNumber && purchaseOrderStepperData?.poNumber)) {
      val.push({
        itemKey: "PurchaseOrderHistory-fleet",
        headerText: "PURCHASE ORDER HISTORY",
        content: <PurchaseOrderHistory fleetRequestDetailId={itemDetails?.fleetRequestDetailId} poNumber={itemDetails?.poNumber} />,
      })
    }
    return val;
  }

  return (
    <>
      <div className="VehicleRequest-detail-fleet p-3">
        {isEmailSentAlert != null && isPoVendorEmailSent?.isValid && itemDetails?.fleetRequestDetailId == isEmailSentAlert?.fleetRequestDetailId ?
          <div className="vehicle-request-stepper mail-Alert"><Alert
            className="alert-message-stepper"
            showAlert={isEmailSentAlert?.showAlert}
            dismissAlert={dismissMailAlert}
            type={isEmailSentAlert?.type}
            text={isEmailSentAlert?.text}
           data-attribute="VehicleRequestDetail_Default_Alerts" /></div>
          : null}
        {//new code for production and management vechile
          itemDetails?.orderRequestSubType === CONSTANTS.PRODUCTION_VEHICLE ? (
            <div className="vehicleTypedetailList production-vehicle">
              <div className="production_vehicle_infos">
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label">Vehicle</Label>
                  <Tooltip content={formatLableValue(itemDetails?.vechileType)} data-attribute="VehicleRequestDetail_Default_Tooltip">
                    <div>{formatLableValue(itemDetails?.vechileType)}</div>
                  </Tooltip>
                </div>
                {itemDetails?.showVehicleCapacity &&
                  <div className="mb-sm-3">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_2">Vehicle Capacity</Label>
                    <Tooltip content={formatLableValue(itemDetails?.vehicleCapacity)} data-attribute="VehicleRequestDetail_Default_Tooltip_2">
                      <div className="vehicle_capacity">{formatLableValue(itemDetails?.vehicleCapacity)}</div>
                    </Tooltip>
                  </div>
                }
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_3"># of doors</Label>
                  <Tooltip content={formatLableValue(itemDetails?.noOfDoors)} data-attribute="VehicleRequestDetail_Default_Tooltip_3">
                    <div>{formatLableValue(itemDetails?.noOfDoors)}</div>
                  </Tooltip>
                </div>
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_4">Upfit Option</Label>
                  <Tooltip content={formatLableValue(itemDetails?.upfitOption)} data-attribute="VehicleRequestDetail_Default_Tooltip_4">
                    <div>{formatLableValue(itemDetails?.upfitOption)}</div>
                  </Tooltip>
                </div>
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_5">Drive Train</Label>
                  <Tooltip content={formatLableValue(itemDetails?.driveTrain)} data-attribute="VehicleRequestDetail_Default_Tooltip_5">
                    <div>{formatLableValue(itemDetails?.driveTrain)}</div>
                  </Tooltip>
                </div>
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_6">Fuel Type</Label>
                  <Tooltip content={formatLableValue(itemDetails?.fuelType)} data-attribute="VehicleRequestDetail_Default_Tooltip_6">
                    <div>{formatLableValue(itemDetails?.fuelType)}</div>
                  </Tooltip>
                </div>
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_7">Logoed</Label>
                  <Tooltip content={formatLableValue(itemDetails?.logoed)} data-attribute="VehicleRequestDetail_Default_Tooltip_7">
                    <div>{formatLableValue(itemDetails?.logoed)}</div>
                  </Tooltip>
                </div>
                <div className="mb-sm-3">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_8">Snow Setup</Label>
                  <Tooltip content={formatLableValue(itemDetails?.snowSetup)} data-attribute="VehicleRequestDetail_Default_Tooltip_8">
                    <div>{formatLableValue(itemDetails?.snowSetup)}</div>
                  </Tooltip>
                </div>
              </div>
              <div className="receiving-branch-inputs-and-receiving-issues-container">
              
              <div className="receiving-branch-inputs">
                <Label data-attribute="VehicleRequestDetail_Default_Label_9">Receiving Branch Inputs</Label>
                <div className="receiving-branch-inputs-content">
                                      <div className="vin-serial-container commonFlexSpace">
                    <div className="vin-serial-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_10">VIN/Serial #</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)} data-attribute="VehicleRequestDetail_Default_Tooltip_9">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_11">VIN/Serial # Mismatch</Label>
                      <Tooltip content={getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)} data-attribute="VehicleRequestDetail_Default_Tooltip_10">
                        <div>{getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)}</div>
                      </Tooltip>
                    </div>
                  </div>
                                      <div className="barcode-fuelcard-container commonFlexSpace">
                    <div className="barcode-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_12">Barcode/Unit#</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)} data-attribute="VehicleRequestDetail_Default_Tooltip_11">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_13">Fuel Card</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)} data-attribute="VehicleRequestDetail_Default_Tooltip_12">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)}</div>
                      </Tooltip>
                    </div>
                  </div>
                                      <div className="mileage-licence-container commonFlexSpace">
                    <div className="mileage-data">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_14">Mileage</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.mileage)} data-attribute="VehicleRequestDetail_Default_Tooltip_13">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.mileage)}</div>
                      </Tooltip>
                    </div>
                    <div className="mb-sm-3">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_15">License Plate Tags</Label>
                      <Tooltip content={itemDetails?.licensePlateTags ?? 'N/A'} data-attribute="VehicleRequestDetail_Default_Tooltip_14">
                        <p>{itemDetails?.licensePlateTags ?? 'N/A'}</p>
                      </Tooltip>
                    </div>
                  </div>
                  <div>
                                          <div className="recieving_issues mb-sm-3 receieveBranchInputs">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_16">Receiving Issues</Label>
                      {itemDetails?.receivingIssues ? ReceivingIssuesList(itemDetails?.receivingIssues) : 'N/A'}
                    </div>
                  </div>
                </div>
              </div>
              </div>
              {isBulkOrder &&
                <>
                  <div className={isBulkOrder ? 'bulkorder' : ''}>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_17">Description</Label>
                    <Tooltip content={formatLableValue(itemDetails?.description)} data-attribute="VehicleRequestDetail_Default_Tooltip_15">
                      <div>{formatLableValue(itemDetails?.description)}</div>
                    </Tooltip>
                  </div>
                  <div className={isBulkOrder ? 'bulkorder' : ''}>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_18">Make</Label>
                    <Tooltip content={formatLableValue(itemDetails?.make)} data-attribute="VehicleRequestDetail_Default_Tooltip_16">
                      <div>{formatLableValue(itemDetails?.make)}</div>
                    </Tooltip>
                  </div>
                  <div className={isBulkOrder ? 'bulkorder' : ''}>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_19">Model</Label>
                    <Tooltip content={formatLableValue(itemDetails?.model)} data-attribute="VehicleRequestDetail_Default_Tooltip_17">
                      <div>{formatLableValue(itemDetails?.model)}</div>
                    </Tooltip>
                  </div>
                </>
              }
            </div>
          ) : null}
        {itemDetails?.orderRequestSubType === CONSTANTS.MANAGEMENT_VEHICLE ? (
          <div className="vehicleTypedetailList management-vehicle">
            <div className="management_vehicle_info">
              <div>
                <Label data-attribute="VehicleRequestDetail_Default_Label_20">Driver Title</Label>
                <Tooltip content={formatLableValue(itemDetails?.driverTitle)} data-attribute="VehicleRequestDetail_Default_Tooltip_18">
                  <div>{formatLableValue(itemDetails?.driverTitle)}</div>
                </Tooltip>
              </div>
              {!isBulkOrder && <div>
                <Label data-attribute="VehicleRequestDetail_Default_Label_21">Driver Details</Label>
                <Tooltip content={formatLableValue(itemDetails?.driverEmployeeFullName)} data-attribute="VehicleRequestDetail_Default_Tooltip_19">
                  <div className="driver_details">{formatLableValue(itemDetails?.driverEmployeeFullName)}</div>
                </Tooltip>
              </div>}
              <div className={isBulkOrder ? 'bulkorder' : ''}>
                <Label data-attribute="VehicleRequestDetail_Default_Label_22">Vehicle</Label>
                <Tooltip content={formatLableValue(itemDetails?.vechileType)} data-attribute="VehicleRequestDetail_Default_Tooltip_20">
                  <div>{formatLableValue(itemDetails?.vechileType)}</div>
                </Tooltip>
              </div>
              <div className={isBulkOrder ? 'bulkorder' : ''}>
                <Label data-attribute="VehicleRequestDetail_Default_Label_23">Drive Train</Label>
                <Tooltip content={formatLableValue(itemDetails?.driveTrain)} data-attribute="VehicleRequestDetail_Default_Tooltip_21">
                  <div>{formatLableValue(itemDetails?.driveTrain)}</div>
                </Tooltip>
              </div>
              <div>
                <Label data-attribute="VehicleRequestDetail_Default_Label_24">Logoed</Label>
                <Tooltip content={formatLableValue(itemDetails?.logoed)} data-attribute="VehicleRequestDetail_Default_Tooltip_22">
                  <div>{formatLableValue(itemDetails?.logoed)}</div>
                </Tooltip>
              </div>
              <div className={isBulkOrder ? 'bulkorder' : ''}>
                <Label data-attribute="VehicleRequestDetail_Default_Label_25">Fuel Type</Label>
                <Tooltip content={formatLableValue(itemDetails?.fuelType)} data-attribute="VehicleRequestDetail_Default_Tooltip_23">
                  <div>{formatLableValue(itemDetails?.fuelType)}</div>
                </Tooltip>
              </div>
            </div>
            <div className="receiving-branch-inputs-and-receiving-issues-container">
            
            <div className="receiving-branch-inputs">
              <Label data-attribute="VehicleRequestDetail_Default_Label_26">Receiving Branch Inputs</Label>
              <div className="receiving-branch-inputs-content">
                <div className="vin-serial-container commonFlexSpace">
                  <div className="vin-serial-no">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_27">VIN/Serial #</Label>
                    <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)} data-attribute="VehicleRequestDetail_Default_Tooltip_24">
                      <div>{formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_28">VIN/Serial # Mismatch</Label>
                    <Tooltip content={getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)} data-attribute="VehicleRequestDetail_Default_Tooltip_25">
                      <div>{getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)}</div>
                    </Tooltip>
                  </div>
                </div>
                <div className="barcode-fuelcard-container commonFlexSpace">
                  <div className="barcode-no">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_29">Barcode/Unit#</Label>
                    <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)} data-attribute="VehicleRequestDetail_Default_Tooltip_26">
                      <div>{formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_30">Fuel Card</Label>
                    <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)} data-attribute="VehicleRequestDetail_Default_Tooltip_27">
                      <div>{formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)}</div>
                    </Tooltip>
                  </div>
                </div>
                <div className="mileage-licence-container commonFlexSpace">
                  <div className="mileage-data">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_31">Mileage</Label>
                    <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.mileage)} data-attribute="VehicleRequestDetail_Default_Tooltip_28">
                      <div>{formatLableValue(itemDetails?.receivingBranchDetails?.mileage)}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="VehicleRequestDetail_Default_Label_32">License Plate Tags</Label>
                    <Tooltip content={itemDetails?.licensePlateTags ?? 'N/A'} data-attribute="VehicleRequestDetail_Default_Tooltip_29">
                      <p>{itemDetails?.licensePlateTags ?? 'N/A'}</p>
                    </Tooltip>
                  </div>
                </div>
                <div className="recieving_issues mb-sm-3 receieveBranchInputs">
                  <Label data-attribute="VehicleRequestDetail_Default_Label_33">Receiving Issues</Label>
                  {itemDetails?.receivingIssues ? ReceivingIssuesList(itemDetails?.receivingIssues) : 'N/A'}
                </div>
              </div>
            </div>
            </div>
            {isBulkOrder &&
              <>
                <div className={isBulkOrder ? 'bulkorder' : ''}>
                  <Label data-attribute="VehicleRequestDetail_Default_Label_34">Description</Label>
                  <Tooltip content={formatLableValue(itemDetails?.description)} data-attribute="VehicleRequestDetail_Default_Tooltip_30">
                    <div>{formatLableValue(itemDetails?.description)}</div>
                  </Tooltip>
                </div>
                <div className={isBulkOrder ? 'bulkorder' : ''}>
                  <Label data-attribute="VehicleRequestDetail_Default_Label_35">Make</Label>
                  <Tooltip content={formatLableValue(itemDetails?.make)} data-attribute="VehicleRequestDetail_Default_Tooltip_31">
                    <div>{formatLableValue(itemDetails?.make)}</div>
                  </Tooltip>
                </div>
                <div className={isBulkOrder ? 'bulkorder' : ''}>
                  <Label data-attribute="VehicleRequestDetail_Default_Label_36">Model</Label>
                  <Tooltip content={formatLableValue(itemDetails?.model)} data-attribute="VehicleRequestDetail_Default_Tooltip_32">
                    <div>{formatLableValue(itemDetails?.model)}</div>
                  </Tooltip>
                </div>
              </>
            }
          </div>
        ) : null}
        {itemDetails?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT ? (
          <div className="equipment-detail">
            <div className="equipmentdetailList">
              <div className={`make ${activeStepper === 4 || activeStepper === 2 ? "commonmakeAlignment" : ""}`}>
                <Label data-attribute="VehicleRequestDetail_Default_Label_37">Equipment Type</Label>
                <Tooltip content={getEquipmentType()} data-attribute="VehicleRequestDetail_Default_Tooltip_33">
                  <div>{getEquipmentType()}</div>
                </Tooltip>
              </div>
              <div className="manageddescription">
                <Label data-attribute="VehicleRequestDetail_Default_Label_38">Description</Label>
                <Tooltip content={formatLableValue(itemDetails?.description)} data-attribute="VehicleRequestDetail_Default_Tooltip_34">
                  <div>{formatLableValue(itemDetails?.description)}</div>
                </Tooltip>
              </div>
              {isBulkOrder &&
                <div className='managedmakebulkorder'>
                  <Label data-attribute="VehicleRequestDetail_Default_Label_39">Make</Label>
                  <Tooltip content={formatLableValue(itemDetails?.make)} data-attribute="VehicleRequestDetail_Default_Tooltip_35">
                    <div>{formatLableValue(itemDetails?.make)}</div>
                  </Tooltip>
                </div>
              }
              <div className="vendordetail">
                <Label data-attribute="VehicleRequestDetail_Default_Label_40">Dealer Details</Label>
                {((itemDetails?.pocipDetails == null || itemDetails?.pocipDetails === undefined) && itemDetails?.poDealerDetails?.hasOwnProperty('vendorABNumber')) ?
                  <Tooltip content={itemDetails?.poDealerDetails?.vendorABNumber + '-' + itemDetails?.poDealerDetails?.dealerName + ', ' + itemDetails?.poDealerDetails?.dealerName + ', ' + itemDetails?.poDealerDetails?.dealerAdd1 + ', ' + (itemDetails?.poDealerDetails?.dealerAdd2 ? itemDetails?.poDealerDetails?.dealerAdd2 + '  ' : "") + (itemDetails?.poDealerDetails?.dealerAdd3 ? itemDetails?.poDealerDetails?.dealerAdd3 + '  ' : "") + itemDetails?.poDealerDetails?.dealerCity + ', ' + itemDetails?.poDealerDetails?.dealerState + ', ' + itemDetails?.poDealerDetails?.dealerZip + ' PH:' + itemDetails?.poDealerDetails?.dealerPhone + ', Email: ' + itemDetails?.poDealerDetails?.dealerContactEmail} data-attribute="VehicleRequestDetail_Default_Tooltip_36">
                    <div>{itemDetails?.poDealerDetails?.vendorABNumber} - {itemDetails?.poDealerDetails?.dealerName}</div>
                    <div>{itemDetails?.poDealerDetails?.dealerName}</div>
                    <div>{itemDetails?.poDealerDetails?.dealerAdd1}, {itemDetails?.poDealerDetails?.dealerAdd2} {itemDetails?.poDealerDetails?.dealerAdd3 ? ',' : ''} {itemDetails?.poDealerDetails?.dealerAdd3} {itemDetails?.poDealerDetails?.dealerAdd3 ? ',' : ''} {itemDetails?.poDealerDetails?.dealerCity}, {itemDetails?.poDealerDetails?.dealerState}, {itemDetails?.poDealerDetails?.dealerZip}</div>
                    <div>PH: {itemDetails?.poDealerDetails?.dealerPhone}, Email: {itemDetails?.poDealerDetails?.dealerContactEmail}</div>
                  </Tooltip> :
                  <Tooltip content={"-"} data-attribute="VehicleRequestDetail_Default_Tooltip_37">
                    -
                  </Tooltip>}
              </div>
              <div className="receiving-branch-inputs">
                <Label data-attribute="VehicleRequestDetail_Default_Label_41">Receiving Branch Inputs</Label>
                <div className="receiving-branch-inputs-content">
                  <div className="vin-serial-container commonFlexSpace">
                    <div className="vin-serial-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_42">VIN/Serial #</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)} data-attribute="VehicleRequestDetail_Default_Tooltip_38">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_43">VIN/Serial # Mismatch</Label>
                      <Tooltip content={getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)} data-attribute="VehicleRequestDetail_Default_Tooltip_39">
                        <div>{getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)}</div>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="barcode-fuelcard-container commonFlexSpace">
                    <div className="barcode-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_44">Barcode/Unit#</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)} data-attribute="VehicleRequestDetail_Default_Tooltip_40">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_45">Fuel Card</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)} data-attribute="VehicleRequestDetail_Default_Tooltip_41">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)}</div>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="mileage-licence-container commonFlexSpace">
                    <div className="mileage-data">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_46">Mileage</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.mileage)} data-attribute="VehicleRequestDetail_Default_Tooltip_42">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.mileage)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_47">License Plate Tags</Label>
                      <Tooltip content={itemDetails?.licensePlateTags ?? 'N/A'} data-attribute="VehicleRequestDetail_Default_Tooltip_43">
                        <p>{itemDetails?.licensePlateTags ?? 'N/A'}</p>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="recieving_issues receieveBranchInputs">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_48">Receiving Issues</Label>
                    {itemDetails?.receivingIssues ? ReceivingIssuesList(itemDetails?.receivingIssues) : 'N/A'}
                  </div>
                </div>
              </div>
            </div>     
          </div>
        ) : null}
        {itemDetails?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT ? (<>
          <div className="nonequipment-detail">
            <div className="nonequipmentdetailList">
              <div className="make">
                <Label required data-attribute="VehicleRequestDetail_Default_Label_49">Make</Label>
                {
                  !enableEditNSE ?
                    <Tooltip content={formatLableValue(itemDetails?.make)} data-attribute="VehicleRequestDetail_Default_Tooltip_44">
                      <div>{formatLableValue(itemDetails?.make)}</div>
                    </Tooltip>
                    : <>
                      <InputField
                        placeholder="Make"
                        value={editAssetInfo?.make}
                        name='make'
                        onChange={(item: any) => onChangeMake(item)}
                        className={editAssetInfo?.makeError?.length > 0 ? 'controlValidation' : ''}
                        disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                       data-attribute="VehicleRequestDetail_make_Input" />
                      {editAssetInfo?.makeError?.length > 0 ? <p className='validMessage'>{editAssetInfo?.makeError}</p> : null}
                    </>
                }
              </div>
              <div className="model">
                <Label required data-attribute="VehicleRequestDetail_Default_Label_50">Model</Label>
                {
                  !enableEditNSE ?
                    <Tooltip content={formatLableValue(itemDetails?.model)} data-attribute="VehicleRequestDetail_Default_Tooltip_45">
                      <div>{formatLableValue(itemDetails?.model)}</div>
                    </Tooltip>
                    : <><InputField
                      placeholder="Model"
                      value={editAssetInfo?.model}
                      name='model'
                      onChange={(item: any) => onChangeModel(item)}
                      className={editAssetInfo?.modelError?.length > 0 ? 'controlValidation' : ''}
                      disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                     data-attribute="VehicleRequestDetail_model_Input" />
                      {editAssetInfo?.modelError?.length > 0 ? <p className='validMessage'>{editAssetInfo?.modelError}</p> : null}
                    </>
                }
              </div>
              <div className="managedyear">
                <Label required data-attribute="VehicleRequestDetail_Default_Label_51">Year</Label>
                {
                  !enableEditNSE ?
                    <Tooltip content={formatLableValue(itemDetails?.year)} data-attribute="VehicleRequestDetail_Default_Tooltip_46">
                      <div>{formatLableValue(itemDetails?.year)}</div>
                    </Tooltip>
                    : <ReactSelectBox
                      options={yearDropdownList}
                      onChange={(item: any) => onChangeYear(item)}
                      value={editAssetInfo?.year}
                      isDisabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                     data-attribute="VehicleRequestDetail_Default_SearchSelectBox" />
                }
              </div>
              <div className="nonmanageddescription">
                <Label required data-attribute="VehicleRequestDetail_Default_Label_52">Used</Label>
                {
                  !enableEditNSE ?
                    <Tooltip content={itemDetails?.isUsed?.toString() == 'true' ? 'Yes' : 'No'} data-attribute="VehicleRequestDetail_Default_Tooltip_47">
                      <div className="descriptionMake">{itemDetails?.isUsed?.toString() === 'true' ? 'Yes' : 'No'}</div>
                    </Tooltip>
                    : <ReactSelectBox
                      options={usedDropdownList}
                      onChange={(item: any) => onChangeUsed(item)}
                      value={editAssetInfo?.isUsed}
                      isDisabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                     data-attribute="VehicleRequestDetail_Default_SearchSelectBox_2" />
                }
              </div>
              <div className="make">
                <Label data-attribute="VehicleRequestDetail_Default_Label_53">Description</Label>
                {
                  !enableEditNSE ?
                    <Tooltip content={formatLableValue(itemDetails?.description)} data-attribute="VehicleRequestDetail_Default_Tooltip_48">
                      <div className="descriptionMake">{formatLableValue(itemDetails?.description)}</div>
                    </Tooltip>
                    : <>
                      <InputField
                        placeholder="Description"
                        value={editAssetInfo?.description}
                        name='description'
                        onChange={(item: any) => onDescriptionChange(item)}
                        className={editAssetInfo?.descriptionError?.length > 0 ? 'controlValidation' : ''}
                        disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                       data-attribute="VehicleRequestDetail_description_Input" />
                      {editAssetInfo?.descriptionError?.length > 0 ? <p className='validMessage'>{editAssetInfo?.descriptionError}</p> : null}
                    </>
                }
              </div>
              
              <div className="vendordetail">
                <Label data-attribute="VehicleRequestDetail_Default_Label_54">Dealer Details</Label>
                {((itemDetails?.pocipDetails == null || itemDetails?.pocipDetails === undefined) && itemDetails?.poDealerDetails?.hasOwnProperty('vendorABNumber')) ?
                  <Tooltip content={itemDetails?.poDealerDetails?.vendorABNumber + '-' + itemDetails?.poDealerDetails?.dealerName + ', ' + itemDetails?.poDealerDetails?.dealerName + ', ' + itemDetails?.poDealerDetails?.dealerAdd1 + ', ' + (itemDetails?.poDealerDetails?.dealerAdd2 ? itemDetails?.poDealerDetails?.dealerAdd2 + '  ' : "") + (itemDetails?.poDealerDetails?.dealerAdd3 ? itemDetails?.poDealerDetails?.dealerAdd3 + '  ' : "") + itemDetails?.poDealerDetails?.dealerCity + ', ' + itemDetails?.poDealerDetails?.dealerState + ', ' + itemDetails?.poDealerDetails?.dealerZip + ' PH:' + itemDetails?.poDealerDetails?.dealerPhone + ', Email: ' + itemDetails?.poDealerDetails?.dealerContactEmail} data-attribute="VehicleRequestDetail_Default_Tooltip_49">
                    <div>{itemDetails?.poDealerDetails?.vendorABNumber} - {itemDetails?.poDealerDetails?.dealerName}</div>
                    <div>{itemDetails?.poDealerDetails?.dealerName}</div>
                    <div>{itemDetails?.poDealerDetails?.dealerAdd1}, {itemDetails?.poDealerDetails?.dealerAdd2} {itemDetails?.poDealerDetails?.dealerAdd3 ? ',' : ''} {itemDetails?.poDealerDetails?.dealerAdd3} {itemDetails?.poDealerDetails?.dealerAdd3 ? ',' : ''} {itemDetails?.poDealerDetails?.dealerCity}, {itemDetails?.poDealerDetails?.dealerState}, {itemDetails?.poDealerDetails?.dealerZip}</div>
                    <div>PH: {itemDetails?.poDealerDetails?.dealerPhone}, Email: {itemDetails?.poDealerDetails?.dealerContactEmail}</div>
                  </Tooltip> :
                  <Tooltip content={"-"} data-attribute="VehicleRequestDetail_Default_Tooltip_50">
                    -
                  </Tooltip>}
              </div>
              
              <div className="receiving-branch-inputs">
                <Label data-attribute="VehicleRequestDetail_Default_Label_55">Receiving Branch Inputs</Label>
                <div className="receiving-branch-inputs-content">
                  <div className="vin-serial-container commonFlexSpace">
                    <div className="vin-serial-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_56">VIN/Serial #</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)} data-attribute="VehicleRequestDetail_Default_Tooltip_51">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.vinSerial)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_57">VIN/Serial # Mismatch</Label>
                      <Tooltip content={getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)} data-attribute="VehicleRequestDetail_Default_Tooltip_52">
                        <div>{getBooleanYesNo(itemDetails?.receivingBranchDetails?.vinSerialMismatch)}</div>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="barcode-fuelcard-container commonFlexSpace">
                    <div className="barcode-no">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_58">Barcode/Unit#</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)} data-attribute="VehicleRequestDetail_Default_Tooltip_53">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.unitNo)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_59">Fuel Card</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)} data-attribute="VehicleRequestDetail_Default_Tooltip_54">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.fuelCard)}</div>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="mileage-licence-container commonFlexSpace">
                    <div className="mileage-data">
                      <Label data-attribute="VehicleRequestDetail_Default_Label_60">Mileage</Label>
                      <Tooltip content={formatLableValue(itemDetails?.receivingBranchDetails?.mileage)} data-attribute="VehicleRequestDetail_Default_Tooltip_55">
                        <div>{formatLableValue(itemDetails?.receivingBranchDetails?.mileage)}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="VehicleRequestDetail_Default_Label_61">License Plate Tags</Label>
                      <Tooltip content={itemDetails?.licensePlateTags ?? 'N/A'} data-attribute="VehicleRequestDetail_Default_Tooltip_56">
                        <p>{itemDetails?.licensePlateTags ?? 'N/A'}</p>
                      </Tooltip>
                    </div>
                  </div>
                  <div className="recieving_issues receieveBranchInputs">
                    <Label data-attribute="VehicleRequestDetail_Default_Label_62">Receiving Issues</Label>
                    {itemDetails?.receivingIssues ? ReceivingIssuesList(itemDetails?.receivingIssues) : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="nonEquipEdit">
              {isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) &&
                <div className='edit-save-block'>
                  <div className="img-block">
                 
                      {
                        !enableEditNSE ?
                                              <EventHandler onEvent={() => handleClickEditNSE(itemDetails)} data-attribute="VehicleRequestDetail_Default_EventHandler">      <img src={editIcon} title='Edit' alt='Edit' />  </EventHandler>
                                              : <EventHandler onEvent={handleClickEditNSE} data-attribute="VehicleRequestDetail_Default_EventHandler_2"> <img src={saveIcon} title='Save' alt='Save' /> </EventHandler>
                      }
                   
                  </div>
                </div>
              }
            </div>
          </div>
        </>) : null}
        <ItemDetail
          orderDetails={orderDetails}
          assignTo={assignTo}
          itemDetails={itemDetails}
          accordionIndex={accordionIndex}
          isnonStandardequipment={isnonStandardequipment}
          handleChange={handleChange}
          purchaseOrderStepperData={purchaseOrderStepperData}
          handleChangeDropDown={handleChangeDropDown}
          errors={errors}
          ismanagedequipment={ismanagedequipment}
          isvehiclerequestequipment={isvehiclerequestequipment}
          activeStepper={activeStepper}
          onCloseLinkAttachment={onCloseLinkAttachment}
          onChangeLinkAttachment={onChangeLinkAttachment}
          onClicktLinkAttachment={onClicktLinkAttachment}
          isAttachmentBtnClicked={isAttachmentBtnClicked}
          getLinkedAttachmentsCount={getLinkedAttachmentsCount}
          attachmentsList={attachmentsList}
          linkedAttachment={linkedAttachment}
          assignedToError={assignedToError}
          check={check}
          onClickAttachment={onClickAttachment}
          savedStatus={savedStatus}
          enableEditNSE={enableEditNSE}
          editAssetInfo={editAssetInfo}
          onChangePrice={onChangePrice}
          unitPriceFormat={unitPriceFormat}
          isBulkOrder={isBulkOrder}
          list={list}
          setList={setList}
          uploadedList={uploadedList}
          onUploadClick={onUploadClick}
          attachmentError={attachmentError}
          setAttachmentError={setAttachmentError}
          onRemoveClick={onRemoveClick}
          autoSaveComments={autoSaveComments}
          onChnageQuoteAttached={onChnageQuoteAttached}
          onClickViewPurchaseOrder={onClickViewPurchaseOrder}
          onClickSendPoToVendor={onClickSendPoToVendor}
          showEmailPopup={showEmailPopup}
          hidePopup={hidePopup}
          handleClickTriggerEmail={handleClickTriggerEmail}
          setSendEmailAttachmentsList={setSendEmailAttachmentsList}
          sendEmailAttachmentsList={sendEmailAttachmentsList}
          setSendEmailList={setSendEmailList}
          sendEmailList={sendEmailList}
          setEmailAttachmentError={setEmailAttachmentError}
          emailAttachmentError={emailAttachmentError}
          sendEmailError={sendEmailError}
          setSendEmailerror={setSendEmailerror}
          dismissMailAlert={dismissMailAlert}
          isEmailSentAlert={isEmailSentAlert}
          isPoVendorEmailSent={isPoVendorEmailSent}
          Popupcontent={Popupcontent}
          hideDialog={hideDialog}
          popupOutlinebtnOnclick={popupOutlinebtnOnclick}
          onClickRefreshPurchaseOrder={onClickRefreshPurchaseOrder}
        />
        <StepperList
          stepperListData={stepperListData}
          panelList={panelList}
          className={`purchaseorder-stepper purchaseorder-stepper_${accordionIndex}`}
          StepperRef={StepperRef}
          activeStepper={activeStepper}
          SelectedVehiclesCount={SelectedVehiclesCount}
          handleClickNext={handleClickNext}
          handleClickPrevious={handleClickPrevious}
          catalogItemDetailsLength={(skipVendorDetail && activeStepper > 1) ? 0 : 2}
          isPOCreated={(activeStepper == 3 && !purchaseOrderStepperData?.poNumber)}
          nextBtnText='Continue Order'
          btnBlockClassName={(activeStepper == 4 || (skipVendorDetail && activeStepper > 1)) ? 'task-btn-block' : (activeStepper == 3 || activeStepper == 2 ? 'vendor-details-block' : '')}
          isComplete={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || isRequisitionComplete?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE}
          onClickReturnToHome={onClickReturnToHome}
          skipVendorDetail={skipVendorDetail}
          showReturnToRequestor={isAuthorized(FLEET_PROCESSING_PERMISSIONS.RETURN_TO_REQUESTOR) &&
            purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.CANCELLED &&
            !purchaseOrderStepperData?.poNumber && !skipVendorDetail && !purchaseOrderStepperData?.alreadyReturnedFromFleet}
          handleClickReturnToRequestor={(e?: any) => handleClickReturnToRequestor(e, itemDetails?.fleetRequestDetailId)}
         data-attribute="VehicleRequestDetail_Default_StepperList" />
        {+error?.itemNumber === +String(itemDetails?.itemId).split("-")[1] && (
          <div className="vehicle-request-stepper"><Alert
            className="alert-message-stepper"
            showAlert={error?.showAlert}
            dismissAlert={dismissAlert}
            type={error?.type}
            text={error?.text}
           data-attribute="VehicleRequestDetail_Default_Alerts_2" /></div>
        )}

        <div className='taskChangeLogAccord'>
          <Tabs
            tabItems={tabItem()}
            handleLinkClick={handleLinkClick}
           data-attribute="VehicleRequestDetail_Default_Tabs" />
        </div>
      </div>
      {
        Popupcontent.isDialogVisible && isRefreshError && (
          <PopupDialogbox
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={popupOutlinebtnOnclick}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={popupOutlinebtnOnclick}
           data-attribute="VehicleRequestDetail_Default_PopupDilalogBox" />
        )
      }
      {returnSuccessPopupContent.isDialogVisible && (
        <PopupDialogbox
          hideDialog={!returnSuccessPopupContent.isDialogVisible}
          onDismiss={() => returnSuccessPopupContent.popupOutlinebtnOnclick()}
          Popupcontent={returnSuccessPopupContent}
          popupOutlinebtnOnclick={() => returnSuccessPopupContent.popupOutlinebtnOnclick()}
         data-attribute="VehicleRequestDetail_Default_PopupDilalogBox_2" />
      )}
      {returnPopupcontent.isDialogVisible &&
        <PopupDialogbox
          hideDialog={!returnPopupcontent.isDialogVisible}
          onDismiss={() => returnPopupcontent?.popupOutlinebtnOnclick()}
          Popupcontent={returnPopupcontent}
          popupOutlinebtnOnclick={() => returnPopupcontent?.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={(
            item: any,
            actionby: string,
            value: any) => returnPopupcontent?.popupPrimarybtnOnclick(item,
              actionby,
              value)}
         data-attribute="VehicleRequestDetail_Default_PopupDilalogBox_3" />}
    </>
  );
};

export default VehicleRequestDetail;
